import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrganizationModule} from '@components/administration/organization/organization.module';
import {MachineGroupModule} from '@components/administration/machine-group/machine-group.module';
import {UserModule} from '@components/administration/user/user.module';
import {MachineModule} from '@components/administration/machine/machine.module';
import {GatewayModule} from '@components/administration/gateway/gateway.module';
import {PortalSetupModule} from '@components/administration/portal-setup/portal-setup.module';
import {MetadataModule} from '@components/administration/metadata/metadata.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OrganizationModule,
    MachineGroupModule,
    UserModule,
    MachineModule,
    GatewayModule,
    PortalSetupModule,
    MetadataModule
  ]
})
export class AdministrationModule {
}
